module.exports = __webpack_public_path__ + "img/nav_application_sydc.30ca83d5.png";